import { fromHouseConsignmentDetailsResponse, toUpdateHouseConsignmentRequest } from '../models/mapper'
import { HouseConsignmentUpdate } from '../models/request'
import { HouseConsignmentDetails } from '../models/types'
import { updateHouseConsignmentDraftV3 } from './http'

// eslint-disable-next-line import/prefer-default-export
export async function updateHouseConsignmentDraft(id: number, data: HouseConsignmentUpdate): Promise<HouseConsignmentDetails> {
  const response = await updateHouseConsignmentDraftV3(id, toUpdateHouseConsignmentRequest(data))
  return fromHouseConsignmentDetailsResponse(response)
}
